import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { IonContent, ModalController } from '@ionic/angular';
import { AcoService } from '../../../api/aco.service';
import { LoaderService } from '../../../services/loader.service';

@Component({
  selector: 'app-comments',
  templateUrl: './comments.page.html',
  styleUrls: ['./comments.page.scss'],
})
export class CommentsPage implements OnInit {

  @ViewChild(IonContent, { static: false }) content: IonContent;
  @Input() task_id;
  comments = [];
  user_id = null;
  message = "";
  div:any;

  constructor(
    private modalController: ModalController,
    private aco: AcoService,
    private ionLoader: LoaderService
  ) { }

  ngOnInit() {
    this.div = document.getElementById('chat');
    this.getComments();
  }

  closeModal(){
    this.modalController.dismiss({
      'dismissed': true
    });
  }

  getComments(){
    this.ionLoader.showLoader();
    this.aco.getToken().then((a) => {
      this.aco.getCommentsTask(this.task_id)
      .subscribe(
        (response) => {
          console.log(response);
          this.ionLoader.hideLoader();
          this.user_id = response['data']['user_id'];

          // Guardar en orden inverso para mostrar el chat mas reciente en ultima posición
          this.comments = [];
          for(let comment of response['data']['comments']){
            this.comments.unshift(comment);
          }

          setTimeout(() => {
            this.contentScrollToBottom();
          }, 50);

        },
        (error) => {
          console.log('bad');
          this.ionLoader.hideLoader();
        }
      );
    });
  }

  contentScrollToBottom(){
    // Ir hasta el final del scroll
    this.content.scrollToBottom(100);
  }

  send_message(){

    if(this.message != ""){

      let message = {
        'message': this.message,
        'user_id': this.user_id,
        'task_id': this.task_id
      };
      this.message = "";

      // Añadir mensaje al chat
      this.comments.push(message);
      this.contentScrollToBottom();

      // Guardar mensaje en BBDD
      this.aco.getToken().then((a) => {
        this.aco.setCommentsTask(message)
        .subscribe(
          (response) => {
            console.log(response);

            // Guardar en orden inverso para mostrar el chat mas reciente en ultima posición
            this.comments = [];
            for(let comment of response['data']['comments']){
              this.comments.unshift(comment);
            }

            setTimeout(() => {
              this.contentScrollToBottom();
            }, 50);

          },
          (error) => {
          }
        );
      });

    }else{
      // Notificar que no hay un comentario
    }
  }

  refresh(){
    this.getComments();
  }

}
